import styled, { css } from 'styled-components'
import { fonts, colors, borders } from '../Styles/common-styles'

const VerticalFlex = styled.div`
    display: flex;
    flex-direction: column;
`
const HorizontalFlex = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-top: 9px;
    margin-bottom: 22px;
`
const BackButton = styled.button`
    color: ${colors.purpleMain};
    font-size: ${fonts.largeSize};
    font-weight: 600;
    line-height: 20px;
    align-items: center;
    background-color: transparent;
`
const SendButton = styled.button`
    transition: all 0.7s ease;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    margin-left: 12px;
    background-color: ${colors.purpleMain};
    &:hover {
      background: ${colors.purpleBright};
    }
`
const Title = styled.span`
    color: ${colors.black};
    font-size: ${fonts.bigSize};
    font-weight: 600;
    line-height: 100%;
    padding-left: 2px;
`
const AddToEventButton = styled.button`
  transition: all 0.7s ease;
  display: flex;
  white-space: nowrap;
  background: ${colors.purpleMain};
  font-weight: 600;
  font-size: ${fonts.normalSize};
  line-height: 18px;
  color: ${colors.white};
  border: 1px solid #5522B5;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 11px 18px;
  &:hover {
    background: ${colors.purpleBright};
  };
  ${props => props.reverse && css`
    background-color: ${colors.white};
    color: ${colors.purpleMain};
    &:hover {
      background: ${colors.purpleBright};
      color: ${colors.white};
    }`
  };

  ${props => props.delete && css`
    background-color: ${colors.white};
    color: ${colors.errorRed};
    border-color: ${colors.errorRed};
    &:hover {
      background: ${colors.errorRedLight};
    }`
  };

  ${props => props.cancel && css`
    background-color: ${colors.white};
    color: ${colors.grey};
    border-color: ${colors.grey};
    &:hover {
      background: ${colors.greyLight};
    }`
  };
`
const VideoFrame = styled.iframe`
  width: 370px;
  height: 214px;
  background: url(${props => props.src || ''});
  border: ${borders.primary};
  border-radius: 6px;
  margin-bottom: 28px;
  // src: 'https://www.youtube.com/embed/5qap5aO4i9A?feature=oembed'
`
// src='https://www.youtube.com/embed/5qap5aO4i9A?feature=oembed' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen />

const PhotoFrame = styled.div`
  width: 370px;
  height: 214px;
  background: url(${props => props.src || ''});
  border: ${borders.primary};
  border-radius: 6px;
  margin-bottom: 28px;
`
const P1 = styled.p`
  font-weight: 600;
  line-height: 130%;
  font-size: ${fonts.largeSize};
`
const P2 = styled.p`
  font-weight: normal;
  line-height: 130%;
  font-size: ${fonts.largeSize};
`

const EditButton = styled.button`
  font-weight: 600;
  padding: 0;
  line-height: 24px;
  font-size: ${fonts.largeSize};
  color: ${colors.purpleMain};
  background-color: transparent;
  margin-left: 28px;
`

const H1 = styled.p`
  font-weight: 600;
  line-height: 24px;
  font-size: ${fonts.largePlusSize};
`
const CommentDiv = styled.div`
  word-wrap: break-word;
  width: 370px;
  background: transparent;
  margin-bottom: 28px;

`
const CommentName = styled.span`
  font-weight: 600;
  font-size: ${fonts.normalSize};
  line-height: 24px;
  color: ${colors.black};
`
const CommentDate = styled.span`
  font-weight: 400;
  font-size: ${fonts.smallSize};
  line-height: 24px;
  color: ${colors.grey};
`
const CommentText = styled.div`
  font-weight: 400;
  font-size: ${fonts.normalSize};
  line-height: 18,2px;
  color: ${colors.black};
  margin-left: 47px;
`
const ModalTitle = styled.span`
  font-size: ${fonts.largeSize};
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0px;
  color: ${colors.black}
`
const SelectionTitle = styled.span`
  margin-top: 26px;
  font-size: ${fonts.largeSize};
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: ${colors.grey}
`

const AutosaveTime = styled.span`
  font-weight: 400;
  font-size: ${fonts.normalSize};
  line-height: 18.2px;
  color: ${colors.grey};
`

export {
  VerticalFlex, HorizontalFlex, BackButton, SendButton, Title,
  AddToEventButton, VideoFrame, P1, P2, H1, CommentDiv, CommentName,
  CommentDate, CommentText, PhotoFrame, ModalTitle, SelectionTitle,
  EditButton, AutosaveTime
}
